import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post(
      "/driver-accounting/bulk-update-restricted-payouts",
      payload
    );
  },
  uploadAck(payload) {
    return Api.put(
      "/driver-accounting/bulk-update-restricted-payouts",
      payload
    );
  },
};
